// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"345":"d7a14e39","455":"7ae3be39","546":"166ceca8","618":"9f5f6a07","636":"6cbd3b19","898":"556fe85e"}[chunkId] + ".css";
};